/**
 * Shared font weight options for EditPanel dropdowns
 * These constants ensure consistency across all widgets and include all available weights
 */

/**
 * Font weight options using numeric CSS values (400, 500, 600, 700, 800, 900)
 * Used by widgets that store font weight as numeric strings
 */
export const FONT_WEIGHT_OPTIONS_NUMERIC: Array<{
  label: string;
  value: string;
}> = [
  { label: "Normal", value: "400" },
  { label: "Medium", value: "500" },
  { label: "Semibold", value: "600" },
  { label: "Bold", value: "700" },
  { label: "Extra Bold", value: "800" },
  { label: "Black", value: "900" },
];

/**
 * Font weight options using CSS keyword values (normal, medium, semibold, bold)
 * Used by widgets that store font weight as CSS keywords
 */
export const FONT_WEIGHT_OPTIONS_KEYWORDS: Array<{
  label: string;
  value: string;
}> = [
  { label: "Normal", value: "normal" },
  { label: "Medium", value: "medium" },
  { label: "Semibold", value: "semibold" },
  { label: "Bold", value: "bold" },
  { label: "Extra Bold", value: "800" }, // CSS doesn't have keyword for 800, use numeric
  { label: "Black", value: "900" }, // CSS doesn't have keyword for 900, use numeric
];

/**
 * Common subsets of font weight options for specific use cases
 */

/**
 * Standard weights (400, 500, 600, 700) - most common use case
 */
export const FONT_WEIGHT_OPTIONS_STANDARD = FONT_WEIGHT_OPTIONS_NUMERIC.slice(
  0,
  4
);

/**
 * Medium to Bold weights (500, 600, 700) - for emphasis without normal
 */
export const FONT_WEIGHT_OPTIONS_MEDIUM_TO_BOLD =
  FONT_WEIGHT_OPTIONS_NUMERIC.slice(1, 4);

/**
 * Normal to Semibold weights (400, 500, 600) - lighter range
 */
export const FONT_WEIGHT_OPTIONS_NORMAL_TO_SEMIBOLD =
  FONT_WEIGHT_OPTIONS_NUMERIC.slice(0, 3);
